import { api, clearSubAccountToken, setTokens, type TokenResponse } from '@/lib/api';

export interface MemberInvitationDetails {
  email: string;
  member_name: string;
  owner_name: string;
}

class MemberInvitationService {
  async validate(token: string): Promise<MemberInvitationDetails> {
    const response = await api.get('/auth/member-invitations/validate', { params: { token } });
    return response.data;
  }

  /** Define a senha do convidado e já persiste a sessão (efêmera) devolvida pela API. */
  async accept(token: string, newPassword: string, confirmPassword: string): Promise<TokenResponse> {
    const response = await api.post('/auth/member-invitations/accept', {
      token,
      new_password: newPassword,
      confirm_password: confirmPassword,
    });
    const tokens: TokenResponse = response.data;

    clearSubAccountToken();
    setTokens(tokens, false);
    return tokens;
  }
}

const memberInvitationService = new MemberInvitationService();
export default memberInvitationService;
